import { IDropdownValue } from '@cian/components/lib/components/abstract_components/dropdown/dropdown';

import { EJsonQueryPriceType } from '../../../../../json_query';

export class CoworkingPriceTypeDropdownModel implements IDropdownValue {
  public readonly label: string;

  public readonly value: EJsonQueryPriceType | 'all';

  public constructor(label: CoworkingPriceTypeDropdownModel['label'], value: CoworkingPriceTypeDropdownModel['value']) {
    this.label = label;

    this.value = value;
  }
}
